// i18n area 'backups' — locale pl-PL (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/backups.pl-PL.meta.json.
import type { enUS } from './backups'

export const plPL: typeof enUS = {
  ckpt: {
    contents: 'Przyjmuje',
    contentsHint:
      'Co może tu wylądować. „Checkpointy” to konfiguracja klastra, „Kopie danych” to kopie maszyn wirtualnych: obie lektury się składają, jedno miejsce docelowe może przyjąć obie.',
    content: { checkpoints: 'Checkpointy', backups: 'Kopie danych' },
    destinationsTitle: 'Cele kopii zapasowych',
    checkpointsTitle: 'Checkpointy',
    restoreTitle: 'Odtwarzanie',
    addDestination: 'Dodaj cel',
    addDestinationTitle: 'Dodaj cel kopii zapasowych',
    editDestinationTitle: 'Edytuj cel',
    storage: 'Storage',
    storageHint:
      'Storage typu katalogowego (dir/NFS/CIFS/CephFS) — artefakty są zwykłymi plikami w namespace platformy.',
    schedule: 'Harmonogram',
    scheduleNone: 'Tylko ręcznie',
    scheduleHourly: 'Co godzinę',
    scheduleDaily: 'Codziennie',
    scheduleWeekly: 'Co tydzień',
    scheduleHour: 'Godzina',
    scheduleWeekday: 'Dzień',
    scheduleHint:
      'Przy checkpointach z harmonogramu nie ma operatora, który wpisze masterpass: sekrety z keystore są pakowane jako placeholdery.',
    retention: 'Retencja',
    retentionHint:
      'Ile zaplanowanych checkpointów zachować — sweeper usuwa najstarsze ponad ten limit. Checkpointy ręczne i te przed odtworzeniem nigdy nie są usuwane.',
    paused: 'Wstrzymane',
    pausedHint:
      'Blackout operatora: dopóki trwa pauza, na tym celu nic się nie planuje i nic nie przycina — polityki danych i checkpointy jednakowo. Trwających przebiegów nigdy się nie dotyka.',
    orphanRuns: '{n} osieroconych przebiegów',
    orphanRunsHint:
      'Zaplanowane przebiegi policy, które już nie istnieją w tym miejscu docelowym: żadna retencja nimi nie rządzi — nigdy nie liczone ani nie przycinane — i tylko ręka je usuwa. Soczewka „backups” w tvirt diagnose wymienia usunięte policy.',
    rescan: 'Ponowna adopcja artefaktów',
    rescanTitle: 'Ponowna adopcja artefaktów {name}',
    rescanHint:
      'Odbudowuje katalog kopii (VM/CT/App) z manifestów artefaktów obecnych w miejscu docelowym. Istniejące wiersze nie są nigdy zmieniane; kopie nieznanych polityk pozostają osierocone (nigdy nie przycinane automatycznie). Gest po odtworzeniu bootstrap.',
    masterpassDrWarning:
      'Scenariusz katastrofy: dyski LUKS wracają TYLKO z checkpointu Z masterpass. Zaplanowane checkpointy pakują wypełniacze — rób okresowo ręczny checkpoint z masterpass.',
    policy: {
      title: 'Polityki backupu danych',
      hint: 'Nazwane polityki: jakie obiekty (kind, tagi, scope), jak często, kiedy przebieg może wystartować i ile kopii trzymać. Gest zaciągu zostaje przy właścicielu obiektu: tagi przypisuje się w jego własnym scope.',
      add: 'Dodaj politykę',
      column: 'Polityki danych',
      name: 'Nazwa',
      nameHint:
        'Etykieta policy, unikalna w obrębie miejsca docelowego. Przebiegi podążają za stałym id policy: zmiana nazwy jest darmowa; usunięcie osieroca jej przebiegi (już nie liczone ani nie przycinane).',
      kindLocked: 'Rodziny obiektów istniejącej policy nie da się zmienić: utwórz nową policy.',
      kindLabel: 'Obiekty',
      kind: { vm: 'Maszyny wirtualne', ct: 'Kontenery', app: 'Aplikacje' },
      tags: 'Selektor tagów',
      tagsHint:
        'Pary tag=wartość rozdzielone przecinkami, łączone AND. Puste tagi i scope nie wybierają niczego — nigdy „wszystkiego”.',
      scopes: 'Scope',
      scopesHint: 'Ścieżki scope (poddrzewa), rozdzielone przecinkami, łączone między sobą OR.',
      windowStart: 'Okno od',
      windowEnd: 'Okno do',
      windowHint:
        'Okno wykonania (HH:MM, czas lokalny; początek za końcem przeskakuje północ). Rządzi tylko STARTEM: przebieg, który je przekroczy, nigdy nie jest zabijany.',
      mode: 'Tryb',
      modeHint: 'Przyrostowy jedzie na rodzinie serii; zerwana seria degraduje do fulla, powiedziane w dzienniku.',
      modeFull: 'Full',
      modeIncremental: 'Przyrostowy',
      requireQuiesce: 'Wymagaj quiesce (guest agent)',
      paused: 'Polityka wstrzymana',
      retentionNone: 'Trzymaj wszystko',
      retentionCount: 'Liczba',
      retentionGfs: 'Pierścienie GFS',
      gfs: { keepLast: 'Ostatnie', daily: 'Dzienne', weekly: 'Tygodniowe', monthly: 'Miesięczne', yearly: 'Roczne' },
      gfsHint:
        'Dla każdego pierścienia trzymany jest najnowszy backup z każdego z ostatnich N okresów. Zatrzymany backup utrzymuje przy życiu cały swój łańcuch — nigdy baza z sierotami.',
      lastRun: 'Ostatni przebieg',
      neverRan: 'nigdy nie wykonano'
    },
    lastCheckpoint: 'Ostatni checkpoint',
    neverRun: 'Nigdy nie utworzono',
    createNow: 'Utwórz checkpoint',
    createNowTitle: 'Utwórz checkpoint — {name}',
    masterpass: 'Masterpass',
    masterpassHint:
      'Chroni sekretne wartości keystore (argon2id → AES-256-GCM, osobno dla każdej wartości). Nigdy nie jest zapisywana: zachowaj ją — bez niej odtworzenie daje placeholdery zamiast prawdziwych sekretów.',
    masterpassEmptyHint: 'Pozostaw puste, aby spakować jawne placeholdery zamiast sekretów.',
    createStarted: 'Checkpoint w toku…',
    destinationInUseError: "'{name}' nadal zawiera checkpointy — najpierw je usuń.",
    origin: 'Pochodzenie',
    originManual: 'ręczny',
    originSchedule: 'zaplanowany',
    originPreRestore: 'przed odtworzeniem',
    originPreChange: 'przed zmianą',
    preChangeRetention: 'Checkpointy przed zmianą',
    preChangeRetentionHint:
      'Puste = wyłączone. Pierwszy zapis konfiguracji po okresie ciszy utrwala tu poprzedni stan (pochodzenie „przed zmianą”); najnowsze są zachowywane do limitu — własna, przycinana retencja.',
    diffTitle: 'Podgląd zmian',
    diffFailed: 'Podgląd nie powiódł się',
    diffRetry: 'Ponów',
    diffCounts: '{changed} do zmiany · {missing} do utworzenia · {extra} nadmiarowe · {equal} identyczne',
    diffChanged: 'zmienia się',
    diffMissing: 'zostałby utworzony',
    diffExtra: 'zostałby usunięty',
    diffJsonb: 'referencje jsonb nieweryfikowalne przed zastosowaniem',
    diffSecret: 'zapieczętowane pola, nieporównywalne',
    diffMore: 'jeszcze {n}…',
    diffNeeded: 'Start uzbraja się, gdy podgląd odzwierciedla wybór.',
    phase: 'Stan',
    phaseRunning: 'w toku',
    phaseComplete: 'ukończony',
    phaseError: 'błąd',
    secrets: 'Sekrety',
    secretsMasterpass: 'masterpass',
    secretsPlaceholders: 'placeholdery',
    size: 'Rozmiar',
    created: 'Utworzono',
    destination: 'Cel',
    download: 'Pobierz .tvbk',
    deleteCheckpoint: 'Usuń checkpoint',
    noCheckpoints: 'Brak checkpointów — utwórz pierwszy z poziomu wybranego celu.',

    // Runda #156 (standardowy dialog): pełna powierzchnia odczytu rekordu
    // backupu — wiersze szczegółów dla pól nigdy niepokazywanych w tabeli.
    families: 'Rodziny',
    generation: 'Generacja',
    completedAt: 'Ukończono',
    errorDetail: 'Szczegóły błędu',
    manifest: 'Manifest',
    restoreHint: 'Wczytaj artefakt .tvbk: eksplorator pokaże jego zawartość, a potem można wybrać, co i jak odtworzyć.',
    uploadFile: 'Wczytaj plik .tvbk',
    uploading: 'Wczytywanie…',
    uploadFailed: 'Nie można otworzyć artefaktu',
    explorerTitle: 'Zawartość checkpointu',
    checkpointFrom: 'Checkpoint klastra {cluster}, utworzony {when} ({origin}, generacja {generation})',
    otherCluster:
      'Ten checkpoint pochodzi z INNEGO klastra ({cluster}) — odtwarzanie między klastrami pojawi się w przyszłej rundzie.',
    encrypted: 'zaszyfrowany',
    objectsCount: '{n} obiektów',
    mode: 'Tryb',
    modeMerge: 'Merge — uzgadnianie: upsert wybranych, nic nie jest usuwane',
    modeOverwrite:
      'Overwrite — wygrywa checkpoint: w całości zaznaczona rodzina zostaje zastąpiona w całości (bieżące wiersze nieobecne w checkpoincie znikają)',
    restoreMasterpassHint:
      'Masterpass, z którą utworzono checkpoint. Bez niej zaszyfrowane sekrety są odtwarzane jako jawne placeholdery.',
    checkMasterpass: 'Sprawdź',
    masterpassOk: 'Masterpass poprawna',
    masterpassWrong: 'Masterpass błędna',
    parachuteDestination: 'Cel kopii zabezpieczającej',
    parachuteHint: 'Zanim task ruszy jakikolwiek wiersz, tworzy tutaj automatyczny checkpoint przed odtworzeniem.',
    summaryTitle: 'Co się wydarzy',
    summaryLine: '{family}: {what} — {mode}',
    summaryWhole: 'cała rodzina',
    summaryObjects: '{n} wybranych obiektów',
    confirmHint: 'Wpisz nazwę klastra ({name}), aby potwierdzić — odtworzenie nadpisuje zadeklarowaną konfigurację.',
    confirmField: 'Nazwa klastra',
    startRestore: 'Odtwórz',
    restoreRunning: 'Odtwarzanie w toku…',
    restoreDone: 'Odtwarzanie ukończone — reconcilery zbiegają do nowej deklaracji.',
    restoreFailed: 'Odtwarzanie nie powiodło się',
    discard: 'Odrzuć',
    selectionEmpty: 'Wybierz co najmniej jedną rodzinę lub obiekt.'
  },

  backup: {
    intro: {
      title: 'Backup danych VM i kontenerów',
      subtitle: 'Cegiełki, z których korzysta zewnętrzne oprogramowanie do backupu',
      whatItIs:
        'TVirt udostępnia cztery prymitywy: snapshoty quiesced, change tracking per dysk, eksport NBD tylko do odczytu i eksport konfiguracji. Sterują nimi Veeam, Bacula, Acronis i spółka.',
      whatItIsNot:
        'TVirt nie jest produktem do backupu: niczego nie planuje, nie stosuje retencji i nie przechowuje żadnego archiwum twoich danych. Retencja, katalogi i polityki odtwarzania zostają po stronie oprogramowania, którego już używasz.'
    },
    cbt: {
      title: 'Śledzenie zmian',
      colVm: 'VM',
      colDisk: 'Dysk',
      colState: 'Stan',
      colBitmaps: 'Bitmapy',
      colObservedAt: 'Zaobserwowano',
      colChangeId: 'Change ID',
      colMechanic: 'Mechanizm',
      stateActive: 'Aktywne',
      stateInactive: 'Wyłączone',
      stateInconsistent: 'Niespójne — następna kopia musi być pełna',
      stateBroken: 'Łańcuch przerwany — wyłącz, potem włącz jako nowy łańcuch',
      stateSnapshots: 'Zawsze włączone — delta między migawkami',
      stateUnavailable: 'Niedostępne na tym dysku',
      mechanic: {
        'qcow2-bitmap': 'Bitmapa qcow2',
        'rbd-snapdiff': 'Diff migawek Ceph',
        'lvm-thin-delta': 'Delta thin poola',
        none: 'Brak'
      },
      empty: 'Brak dysków VM. Śledzenie zmian czyta się per dysk: włącz je na dysku qcow2 albo rób migawki na rbd/SAN.',
      chainBroken: 'Łańcuch przerwany',
      chainBrokenText:
        'Przerwany przez {reason}: {bitmaps}. Wyłącz bitmapę (łańcuch przepadł, następna kopia jest pełna), potem włącz ją jako nowy łańcuch.',
      lineages: 'Epoki',
      epochFrozen: 'zamrożona w migawce {snapshot}',
      epochLost: 'utracona ({cause})',
      epochRecording: 'nagrywa na głowicy',
      milestones: 'Kamienie milowe (migawki)',
      enable: 'Włącz śledzenie zmian',
      disable: 'Wyłącz',
      reset: 'Zresetuj',
      changedAreas: 'Zmienione obszary',
      denied: 'Brak uprawnień na tej VM',
      enableTitle: 'Włącz śledzenie zmian',
      disableTitle: 'Wyłącz śledzenie zmian',
      resetTitle: 'Zresetuj bitmapę',
      areasTitle: 'Zmienione obszary',
      bitmapName: 'Nazwa bitmapy',
      bitmapNameHint: 'Własna nazwa: tvirt- i tvbk- należą do platformy',
      granularity: 'Ziarnistość (bajty)',
      granularityHint: 'Potęga dwójki; domyślnie 65536',
      bitmap: 'Bitmapa',
      disableHint: 'Usuwa bitmapę i całą historię jej epok: następna kopia musi być pełna.',
      resetHint: 'Opróżnia bitmapę — nowa baza: change ID sprzed resetu nie da się już złożyć.',
      areasFrom: 'Od migawki',
      areasTo: 'Do migawki',
      areasRun: 'Oblicz',
      areasResult: '{count} zmienionych obszarów, {bytes}',
      areasEmpty: 'Brak zmienionych obszarów między dwiema migawkami',
      areasZero: 'zera',
      areasMore: 'pokazano pierwsze {shown} z {count}',
      submit: 'Potwierdź',
      error: 'Akcja śledzenia zmian nie powiodła się'
    },
    exports: {
      title: 'Otwarte eksporty NBD',
      colVm: 'VM',
      colDisk: 'Dysk',
      colSnapshot: 'Migawka',
      colBitmap: 'Bitmapa',
      colPhase: 'Faza',
      colNode: 'Węzeł',
      colEndpoint: 'Endpoint',
      colExpires: 'Wygasa',
      colCreated: 'Otwarty',
      colError: 'Błąd',
      phase: {
        preparing: 'Przygotowanie',
        ready: 'Gotowy',
        closed: 'Zamknięty',
        error: 'Nieudany'
      },
      expiresIn: 'za {minutes} min',
      expired: 'wygasł',
      empty: 'Brak eksportów. Sesja odczytu serwuje jeden dysk w jednej migawce klientowi NBD; sesja zapisu wypełnia dziewiczy dysk zatrzymanej VM. Obie giną po wygaśnięciu.',
      endpointHint: 'TLS z CA klastra; nazwa eksportu to bilet — umiera wraz z sesją',
      closeDenied: 'Brak uprawnień do zamykania eksportów tej VM',
      open: 'Otwórz eksport NBD',
      openTitle: 'Otwórz eksport NBD',
      openDisk: 'Dysk',
      openBitmap: 'Bitmapa (opcjonalnie)',
      openBitmapHint:
        'Publikuje epokę tej bitmapy zamrożoną w tej migawce jako meta-context zmienionych ekstentów (tylko dyski qcow2)',
      openTtl: 'Czas życia (minuty)',
      openSubmit: 'Otwórz',
      openError: 'Nie udało się otworzyć eksportu',
      colMode: 'Tryb',
      mode: {
        read: 'Odczyt',
        write: 'Zapis'
      },
      caCertificate: 'CA klastra',
      caCopy: 'Kopiuj PEM',
      caDownload: 'Pobierz ca-cert.pem',
      caHint: 'Zapisz PEM do ca-cert.pem w prywatnym katalogu i połącz się przez nbds://…?tls-certificates=<katalog> (nbdcopy, nbdinfo) lub --object tls-creds-x509,dir=<katalog>,endpoint=client (qemu-img)',
      caAbsent: 'Sesja nie niesie CA (brak PKI)',
      openWrite: 'Otwórz eksport zapisu',
      openWriteTitle: 'Otwórz eksport zapisu',
      openWriteIntro: 'Dysk musi być dziewiczy: urodzony pusty, nigdy niezapisany, bez migawki; VM zatrzymana. Przywracanie WYPEŁNIA dysk, nie naprawia go. Dopóki sesja jest otwarta, VM nie uruchomi się, nie zrobi migawki, nie sklonuje się, a dysk nie przeniesie się.',
      openWriteSubmit: 'Otwórz',
      openWriteError: 'Nie udało się otworzyć eksportu zapisu',
      openWriteDenied: 'Brak uprawnienia vm.restore.data na tej VM',
      openWriteStopped: 'Zatrzymaj VM, aby otworzyć eksport zapisu',
      fromDescription: 'Utwórz VM z opisu',
      fromDescriptionTitle: 'Utwórz VM z opisu',
      fromDescriptionIntro: 'Opis z export-vm-meta wraca jako zatrzymana VM z pustymi dyskami opisanej geometrii — gotowa na eksporty zapisu, dysk po dysku. Bajty nie przechodzą tędy: niesie je restore-disk (CLI) lub klient NBD produktu do kopii zapasowych.',
      fromDescriptionDoc: 'Opis (JSON)',
      fromDescriptionDocHint: 'Wklej dokument z export-vm-meta lub wybierz plik',
      fromDescriptionFile: 'Wybierz plik…',
      fromDescriptionInvalid: 'Tekst nie jest dokumentem JSON',
      fromDescriptionName: 'Nazwa nowej VM',
      fromDescriptionScope: 'Scope',
      fromDescriptionScopeHome: 'Twój scope domowy',
      fromDescriptionStorage: 'Magazyn dysków',
      fromDescriptionStorageHint: 'Każdy dysk rodzi się tutaj, w domyślnym formacie magazynu',
      fromDescriptionMetadataStorage: 'Magazyn metadanych',
      fromDescriptionSameAsStorage: 'Ten sam co dysków',
      fromDescriptionBridge: 'Bridge',
      fromDescriptionBridgeHint: 'Bez bridge\'a ani sieci VM rodzi się bez kart',
      fromDescriptionNetwork: 'Sieć logiczna (fabric/sieć)',
      fromDescriptionSubmit: 'Utwórz',
      fromDescriptionError: 'Nie udało się utworzyć VM',
      fromDescriptionDone: 'VM utworzona: {name}',
      fromDescriptionOpen: 'Otwórz VM',
      fromDescriptionDenied: 'Brak uprawnienia vm.create',
      fromDescriptionStillRunning: 'Tworzenie wciąż trwa: czekamy dalej'
    },

    // Il MOTORE integrato (#28) — i backup dei dati che TVirt fa davvero.
    vm: {
      title: 'Kopie danych maszyn wirtualnych',
      titleOnVm: 'Kopie danych',
      empty:
        'Brak kopii. Kopia przenosi dyski, varstore UEFI i stan vTPM do miejsca docelowego i przeżywa maszynę wirtualną.',
      colVm: 'VM',
      colCreated: 'Wykonana',
      colPhase: 'Wynik',
      colDestination: 'Miejsce docelowe',
      colContains: 'Zawartość',
      colSize: 'Rozmiar',
      colOrigin: 'Pochodzenie',
      colMode: 'Typ',
      retentionChip: 'Retencja',
      retentionHint:
        'Retencja miejsca docelowego może usunąć tę kopię bez pytania: narodziła się z harmonogramu. Kopie ręczne nigdy nie są zamiatane.',
      policyRemoved: 'Policy usunięta: {name}',
      policyRemovedHint:
        'Policy, która zaplanowała ten backup, już nie istnieje: żadna retencja nim nie rządzi (nigdy nie przycinany automatycznie) — usuń go ręcznie, gdy nie będzie już potrzebny.',
      phase: {
        running: 'W toku',
        complete: 'Ukończona',
        error: 'Nieudana'
      },
      origin: {
        manual: 'Ręczna',
        schedule: 'Zaplanowana'
      },
      mode: {
        full: 'Pełna',
        incremental: 'Przyrostowa'
      },
      contains: {
        disks: 'Dyski',
        varstore: 'Varstore UEFI',
        vtpm: 'Stan vTPM',
        snapshots: 'Migawki'
      },
      vmState: {
        stopped: 'VM wyłączona',
        running: 'VM uruchomiona (na gorąco)'
      },
      artifactClass: { metadata: 'Metadane', data: 'Dane', secret: 'Sekret' },
      detail: {
        tabOverview: 'Podsumowanie',
        tabArtefact: 'Artefakt',
        id: 'Identyfikator',
        scope: 'Zakres',
        vmState: 'Stan VM w chwili kopiowania',
        pointInTime: 'Chwila danych',
        completedAt: 'Zakończona',
        node: 'Węzeł, który kopiował',
        error: 'Błąd',
        path: 'Katalog na magazynie',
        checksum: 'sha256 manifestu',
        secretsExposed: 'Materiał wrażliwy jawnym tekstem',
        secretsExposedYes: 'Tak — miejsce docelowe nie szyfruje',
        secretsExposedNo: 'Nie',
        baseBackup: 'Kopia bazowa',
        tabManifest: 'Manifest',
        manifestHint:
          'Jawny indeks artefaktu: jeden plik na wiersz wraz z jego sha256. Katalog da się zweryfikować bez TVirt — wystarczą qemu-img, tar i jq.',
        manifestEmpty: 'Manifest nie wymienia plików.',
        manifestError: 'Manifestu nie da się odczytać',
        colEntry: 'Plik',
        colClass: 'Klasa',
        colSha: 'sha256'
      },
      create: {
        action: 'Wykonaj kopię teraz',
        title: 'Wykonaj kopię teraz',
        submit: 'Uruchom kopię',
        destination: 'Miejsce docelowe',
        destinationHint: 'Tylko miejsca docelowe przyjmujące kopie.',
        noDestinations: 'Żadne miejsce docelowe nie przyjmuje kopii: utwórz je w System → Checkpointy.',
        contentsHint:
          'Jadą wszystkie dyski, varstore UEFI i stan vTPM. Te dwa ostatnie są sednem: zapieczętowany gość musi znów wystartować.',
        error: 'Kopia nie wystartowała',
        stillRunning: 'Kopia wciąż trwa — kopiowanie idzie dalej, nawet jeśli zamkniesz.',
        vmRunning:
          'Maszyna jest {phase}: kopia wymaga ustabilizowanej VM — wyłączonej dla kopii na zimno, uruchomionej dla kopii na gorąco.'
      },
      restore: {
        action: 'Przywróć',
        title: 'Przywróć',
        intro:
          'Przywracanie jest nieodwracalne. Wybierz, dokąd wracają dane: do nowej maszyny albo na tę, z której pochodzą.',
        modeNewVm: 'Przywróć do NOWEJ maszyny',
        modeNewVmHint:
          'Nie rusza niczego, co istnieje — tą opcją weryfikuje się kopię. Nowy identyfikator i świeżo wybite adresy MAC.',
        modeOver: 'Nadpisz maszynę źródłową',
        modeOverHint: 'Niszczy obecne dane maszyny docelowej, bez odwrotu. Maszyna musi być wyłączona.',
        newName: 'Nazwa nowej maszyny',
        newNameHint: 'Musi być wolna w zakresie docelowym.',
        storage: 'Magazyn dla dysków',
        storageHint: 'Wymagane: manifest zapisuje rozmiar i format dysku, nigdy magazyn, na którym leżał.',
        metadataStorage: 'Magazyn dla varstore i vTPM',
        metadataStorageHint: 'Gdzie lądują tożsamość UEFI i stan vTPM.',
        sameAsStorage: 'Ten sam co dyski',
        bridge: 'Bridge hosta',
        bridgeHint:
          "Każda zapisana karta sieciowa wraca na tym bridge'u z nowym MAC. Pozostawione puste — maszyna rodzi się bez kart, co jest bezpieczniejszym domyślnym wyborem.",
        overwriteTitle: 'Zamierzasz nadpisać tę maszynę',
        overwriteName: 'Nazwa',
        overwriteId: 'Identyfikator',
        overwriteDisks: 'Dyski, które zostaną nadpisane',
        overwriteNoDisks: 'Brak dysków.',
        overwriteKeeps:
          'Nietknięte zostają identyfikator, nazwa, zakres, karty sieciowe i adresy MAC: kopia to DANE, konfiguracja to checkpoint.',
        confirmField: 'Nazwa maszyny',
        confirmHint: 'Wpisz {name}, aby potwierdzić.',
        targetLoading: 'Odczyt maszyny docelowej…',
        targetRunning:
          'Maszyna docelowa jest {phase}: przywracanie nadpisuje bajty pod gościem, więc wymaga jej wyłączenia.',
        targetGone: 'Maszyny źródłowej nie da się już odczytać: pozostaje przywrócenie do nowej maszyny.',
        onlyComplete: 'Kopia jest {phase}: przywrócić może tylko kopia ukończona.',
        submitNewVm: 'Przywróć do nowej maszyny',
        submitOver: 'Nadpisz',
        error: 'Przywracanie nie wystartowało',
        stillRunning: 'Przywracanie wciąż trwa — kopiowanie całych dysków wymaga czasu.'
      }
    },
    guest: {
      title: {
        ct: 'Kopie zapasowe danych kontenerów',
        app: 'Kopie zapasowe danych App'
      },
      tabTitle: 'Kopie zapasowe',
      empty: 'Brak kopii. Kopia przenosi trwałe dane na miejsce docelowe i przeżywa swój obiekt.',
      colSubject: {
        ct: 'Kontener',
        app: 'App'
      },
      colCreated: 'Wykonana',
      colPhase: 'Wynik',
      colDestination: 'Miejsce docelowe',
      colContains: 'Zawartość',
      colSize: 'Rozmiar',
      colOrigin: 'Pochodzenie',
      policyRemoved: 'Policy usunięta: {name}',
      policyRemovedHint:
        'Policy, która zaplanowała ten backup, już nie istnieje: żadna retencja nim nie rządzi (nigdy nie przycinany automatycznie) — usuń go ręcznie, gdy nie będzie już potrzebny.',
      phase: {
        running: 'W toku',
        complete: 'Ukończona',
        error: 'Nieudana'
      },
      origin: {
        manual: 'Ręczna',
        schedule: 'Zaplanowana'
      },
      state: {
        stopped: 'Obiekt zatrzymany',
        running: 'Obiekt działa (zamrożony)'
      },
      contains: {
        rootfs: 'Drzewo rootfs',
        config: 'Konfiguracja',
        volumes: 'Trwałe wolumeny',
        root: 'Trwały root'
      },
      artifactClass: {
        metadata: 'Metadane',
        data: 'Dane',
        secret: 'Sekret'
      },
      create: {
        action: 'Wykonaj kopię teraz',
        title: 'Nowa kopia zapasowa',
        submit: 'Uruchom kopię',
        error: 'Kopia nie wystartowała',
        destination: 'Miejsce docelowe',
        destinationHint: 'Tylko miejsca docelowe przyjmujące kopie danych.',
        noDestinations:
          'Żadne miejsce docelowe nie przyjmuje kopii danych: dodaj do miejsca docelowego „Kopie danych”.',
        hint: {
          ct: 'Podróżuje całe drzewo rootfs, wiernie (numeryczni właściciele, xattr, ACL), plus zadeklarowana konfiguracja w manifeście. Działający kontener jest ZAMRAŻANY na czas pakowania: kopia crash-consistent, zadeklarowana.',
          app: 'Podróżują TYLKO trwałe wolumeny (i trwały root), plus konfiguracja w manifeście. Efemeryczne jest wykluczone ratyfikacją i manifest je wymienia; wartości env zadeklarowane jako tajne nie podróżują.'
        },
        stillRunning: 'Kopia wciąż w toku — pakowanie całych drzew trwa.'
      },
      detail: {
        tabOverview: 'Przegląd',
        tabManifest: 'Manifest',
        id: 'Identyfikator',
        scope: 'Zakres',
        state: 'Stan przy kopii',
        pointInTime: 'Dane na chwilę',
        completedAt: 'Zakończona',
        node: 'Węzeł, który kopiował',
        error: 'Błąd',
        path: 'Katalog w magazynie',
        checksum: 'sha256 manifestu',
        manifestHint: 'Indeks artefaktu: jeden wpis na plik z jego sha256 — bez hashy „kopia tam jest” to akt wiary.',
        manifestError: 'Nie można odczytać manifestu',
        manifestEmpty: 'Brak artefaktów w manifeście.',
        colEntry: 'Plik',
        colClass: 'Klasa',
        colSha: 'sha256',
        excluded: 'Wykluczone ratyfikacją (nie podróżuje)',
        secretKeys: 'Pominięte tajne klucze env (#307) — po przywróceniu wpisz je ponownie'
      },
      restore: {
        action: 'Przywróć',
        title: 'Przywracanie',
        submit: 'Przywróć',
        error: 'Przywracanie nie wystartowało',
        stillRunning: 'Przywracanie wciąż w toku — rozpakowywanie całych drzew trwa.',
        onlyComplete: 'Kopia jest {phase}: przywrócić może tylko ukończona kopia.',
        asNew: {
          ct: 'Do NOWEGO kontenera — niczego nie niszczy: gest, którym sprawdza się kopię',
          app: 'Do NOWEJ App — niczego nie niszczy: gest, którym sprawdza się kopię'
        },
        over: {
          ct: 'NA kontener źródłowy — całe drzewo rootfs zostaje zastąpione',
          app: 'NA App źródłową — zawartość każdego trwałego wolumenu zostaje zastąpiona'
        },
        name: 'Nazwa nowego obiektu',
        storage: 'Magazyn',
        storageHint: 'Gdzie lądują przywrócone dane — manifest nigdy nie zapisuje utraconego poola.',
        storageDeclared: 'Magazyny zadeklarowane w manifeście',
        bridge: 'Bridge hosta',
        bridgeHint:
          'Każda zapisana karta wraca na ten bridge ze świeżym MAC-iem. Puste = rodzi się niepodłączony, najbezpieczniejsze domyślne.',
        node: 'Węzeł',
        nodeHint: 'Członek, na którym App się odradza: węzeł to tożsamość klastra i nigdy nie pochodzi z manifestu.',
        secretKeysWarning:
          'Wartości env zadeklarowane jako tajne nie podróżują w kopii: odrodzona kopia chce ich ponownego wpisania (log zadania wymienia klucze).',
        overInventory: 'Zaraz nadpiszesz ten obiekt',
        confirmType: 'Wpisz {name}, aby potwierdzić',
        targetGone: 'Obiektu źródłowego nie można już odczytać: pozostaje przywrócenie jako nowy.',
        targetLoading: 'Odczyt obiektu docelowego…',
        targetRunning: 'Obiekt docelowy działa: przywracanie zastępuje bajty pod gościem, więc chce go zatrzymanego.'
      }
    }
  }
}
